import React, { useState, useEffect, useContext } from "react";
import { Tabs, Tab, Alert } from "react-bootstrap";
import ContactUsContent from "./ContactUsContent";
import PaymentContent from "./PaymentContent";
import TestimonialContent from "./TestimonialContent";
import CartContent from "./CartContent";
import OrderContent from "./OrderContent";
import QuickTabs from "./QuickTabs";
import SubscriptionContent from "./SubscriptionContent";
import CustomerContent from "./CustomerContent";
import { AuthContext } from "../../../contexts/AuthContext";

function ContentSelectionMenu({ activeKey, setParent, parent }) {
  const [activeTab, setActiveTab] = useState("quick");
  const { userAuthState, role } = useContext(AuthContext);

  // Load saved tab index from localStorage on mount
  useEffect(() => {
    const savedTab = localStorage.getItem("activeDashboardTab");
    if (savedTab) {
      setActiveTab(savedTab);
    }
  }, [role]);

  // Save tab index to localStorage whenever changed
  const handleTabSelect = (key) => {
    setActiveTab(key);
    localStorage.setItem("activeDashboardTab", key);
  };
  return (
    <>
      {role && (
        <Tabs
          defaultActiveKey={activeKey}
          activeKey={activeTab}
          onSelect={handleTabSelect}
          id="uncontrolled-tab-example"
        >
          <Tab eventKey="quick" title="Important Stats" className="p-0">
            <QuickTabs />
          </Tab>
          {role?.toLowerCase() === "admin" && [
            <Tab
              eventKey="Subscriptions"
              title="Subscriptions"
              className="p-2"
              key="sub"
            >
              <SubscriptionContent setParent={setParent} parent={parent} />
            </Tab>,
            <Tab eventKey="Orders" title="Orders" className="p-2" key="orders">
              <OrderContent setParent={setParent} parent={parent} />
            </Tab>,
            <Tab
              eventKey="Customers"
              title="Customers"
              className="p-2"
              key="cust"
            >
              <CustomerContent setParent={setParent} parent={parent} />
            </Tab>,
            <Tab eventKey="Payment" title="Payments" className="p-2" key="pay">
              <PaymentContent setParent={setParent} parent={parent} />
            </Tab>,
          ]}

          <Tab
            eventKey="Online Submissions"
            title="Online Submissions"
            className="p-2"
          >
            <TestimonialContent setParent={setParent} parent={parent} />
          </Tab>
        </Tabs>
      )}
    </>
  );
}

export default ContentSelectionMenu;
